export const SEEN_STORAGE_KEY = 'nav_impact_stats_seen';

export type SeenMetric = 'citations' | 'paperViewsTotal';

export type SeenValues = Partial<Record<SeenMetric, number>>;

function parseSeenValues(raw: string): SeenValues {
  try {
    const parsed: unknown = JSON.parse(raw);
    if (
      parsed != null &&
      typeof parsed === 'object' &&
      !Array.isArray(parsed)
    ) {
      return parsed as SeenValues;
    }
  } catch {
    return {};
  }
  return {};
}

export function readSeenValues(): SeenValues | null {
  let raw: string | null;
  try {
    raw = window.localStorage.getItem(SEEN_STORAGE_KEY);
  } catch {
    return null;
  }
  if (raw == null) {
    return {};
  }
  return parseSeenValues(raw);
}

export function acknowledgeSeenValue(
  metric: SeenMetric,
  value: number,
): SeenValues | null {
  const seen = readSeenValues();
  if (seen == null) {
    return null;
  }
  const merged = { ...seen, [metric]: value };
  try {
    window.localStorage.setItem(SEEN_STORAGE_KEY, JSON.stringify(merged));
  } catch {
    return null;
  }
  return merged;
}

export function dotVisible(
  seen: SeenValues | null,
  metric: SeenMetric,
  current: number | null,
): boolean {
  if (current === 0) {
    return false;
  }
  if (seen == null || current == null) {
    return true;
  }
  return seen[metric] !== current;
}
